import { styled } from '@mui/material';
import { HelixPalette } from '../../../helix';
/**
 * Styled button for the Filter.
 */
export const HelixFilter = styled('button')(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.white,
    border: `2px solid ${HelixPalette.white}`,
    borderRadius: '0.5rem',
    display: 'flex',
    height: 36,
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: '6px 4px 6px 8px',
    whiteSpace: 'nowrap',
    width: 'fit-content',
    '&:hover': { backgroundColor: HelixPalette.neutral05, cursor: 'pointer' },
    '&:focus': { outline: 'none' },
    '&:active:focus': { backgroundColor: HelixPalette.neutral10 },
    '&:focus-visible': { borderColor: HelixPalette.blue70 },
    '&[aria-expanded=true]': {
        backgroundColor: HelixPalette.neutral90,
        borderColor: HelixPalette.neutral90,
        svg: { fill: HelixPalette.white },
    },
}));
